import styled from "styled-components"

import SVGIcon from "components/presenters/common/SVGIcon"

export default function OrderShippingTracking({
  id,
  whiteboxRef,
  trackingNo,
  courierName,
  onClose,
  onCopy,
}) {
  return (
    <Whitebox ref={whiteboxRef}>
      <CloseBtn onClick={() => onClose(id)}>
        <SVGIcon name="close" />
      </CloseBtn>
      <TruckIconBlock>
        <SVGIcon name="truckIcon" />
      </TruckIconBlock>
      <TrackingInfo>{`${courierName} ${trackingNo}`}</TrackingInfo>
      <CopyBtn onClick={() => onCopy(id, trackingNo)}>송장번호 복사하기</CopyBtn>
    </Whitebox>
  )
}

const Whitebox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: calc(100vw * (9 / 375));
  width: calc(100vw * (280 / 375));
  padding-top: calc(100vw * (35 / 375));
  padding-bottom: calc(100vw * (22 / 375));
  padding-left: calc(100vw * (24 / 375));
  padding-right: calc(100vw * (24 / 375));
`

const CloseBtn = styled.button`
  position: absolute;
  top: calc(100vw * (17 / 375));
  right: calc(100vw * (17 / 375));
  width: calc(100vw * (14 / 375));
  height: calc(100vw * (14 / 375));

  svg {
    color: #4e4e4e;
  }
`

const TruckIconBlock = styled.div`
  width: calc(100vw * (35 / 375));
  height: calc(100vw * (26 / 375));
  margin-bottom: calc(100vw * (19 / 375));
`

const TrackingInfo = styled.span`
  font-size: calc(100vw * (16 / 375));
  font-weight: 400;
  line-height: calc(100vw * (16 / 375));
  text-decoration: underline;
  text-underline-position: under;
  margin-bottom: calc(100vw * (30 / 375));
`

const CopyBtn = styled.button`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  line-height: calc(100vw * (24 / 375));
  color: #121212;
  background-color: #ffcf19;
  border-radius: calc(100vw * (8 / 375));
  text-align: center;
  width: 100%;
  padding: calc(100vw * (14 / 375)) 0;
`
